import Vue from 'vue'
import Vuex from 'vuex'
import axios from 'axios';
import Child from './modules/Child.store';
import Couple from './modules/Couple.store';
import Pet from './modules/Pet.store';
import Miscarriage from './modules/Miscarriage.store';
import Moves from './modules/Moves.store';
import AstralCard from './modules/AstralCard.store';
import Appoinments from "./modules/Appoinments.store";
import Accounting from "./modules/Accounting.store"
import $day from "dayjs"
Vue.use(Vuex)

export default new Vuex.Store({
  modules: {
    user : {
      namespaced: true,
      state: {
        info: {},
        users: [],
        tableUsers: [],
        currentUser: null
      },
      mutations: {
        setInfo: (state, info) => {
          info.user_data = info.user_data ? info.user_data:{}
          state.info = info
        },
        updateInfo: (state, info) => state.info.user_data = info.user_data,
        setUsers: (state, info) => {
          info.users = info.users ? info.users:[]
          state.users = info
        },
        setTableUsers: (state, info) => {
          info.users = info.users ? info.users:[]
          state.tableUsers = info
        },
        updateCurrentUser: (state, info) => state.currentUser = info
      },
      actions: {
        async getUsers ({commit}, data)  {
          const response = await axios.get(`admin/users?${data.searchBy}=` + data.val)
          commit ('setUsers', response.data)
        },
        async getAllUsers ({commit}, data)  {
          let query = ''
          if (data && data.search) {
            query = `admin/users?searchUser=${data.search}`
          } else {
            query = data && data.url ? data.url: `admin/users`
          }
          const response = await axios.get(query)
          commit ('setTableUsers', response.data)
        },
        async fetchInfo ({commit, state}) {
          const response = await axios.get('admin/users/data/'+state.currentUser)
          commit ('setInfo', response.data)
        },
        async fetchAllCSV () {
          await axios.get('/admin/users/csv').then((response) => {
            const url = window.URL.createObjectURL(new Blob([response.data]));
            const link = document.createElement('a');
            link.href = url;
            link.setAttribute('download', 'informacion-usuario.csv'); //or any other extension
            document.body.appendChild(link);
            link.click();
          });
          // commit ('setAllCSV', response.data)
        },
        async fetchUserCSV ({state}, email) {
          // await axios.get('/admin/users/csv?email='+email).then((response) => {
          await axios.get('/admin/users/data/'+state.currentUser).then((response) => {
            // let acu = this.formatTxt(response.data)
            // init formatTXt
            // let obj = JSON.parse('{"user_data":{"id":9601,"user_id":9601,"names":"Jean Paul","surnames":"Diaz Vivanco","document":"71842625","phone":"989712992","birth_date":"2012-05-03 00:03:00","born_place":"Madrid","born_country":"Espa\u00f1a","created_at":"2020-11-01T20:26:16.000000Z","updated_at":"2020-11-02T05:56:48.000000Z","current_country":"Per\u00fa","current_place":"Lima","last_birthday_country":"Francia","last_birthday_place":"Auvergne","phone_dial":"+51","display_name":"Jean Paul Diaz Vivanco","user":[{"id":9601,"email":"jeanpaul1304@gmail.com","user_image":"","created_at":"2020-11-01T19:42:47.000000Z","updated_at":"2020-11-23T23:00:25.000000Z","legacy_id":9885,"display_name":"sdgsdg sdgsdg","user_type":1}],"user_pet":[{"id":111,"user_id":9601,"names":"Catalina","born_place":"Sant Julia de Loria","born_country":"Andorra","birth_date":"2020-11-24 04:20:00","created_at":"2020-11-02T06:15:00.000000Z","updated_at":"2020-11-02T06:15:00.000000Z"}],"user_children":[{"id":304,"user_id":9601,"names":"Jean Paul Junior","born_place":"Ordino","born_country":"Andorra","created_at":"2020-11-02T05:57:10.000000Z","updated_at":"2020-11-02T05:57:10.000000Z","surnames":"Diaz Diaz","birth_date":"2020-11-04 04:20:00"}],"user_couple":[{"id":158,"user_id":9601,"names":"Karen","relationship":"Pareja","born_place":"Batna","born_country":"Algeria","birth_date":"2020-11-18 05:25:00","created_at":"2020-11-02T05:57:27.000000Z","updated_at":"2020-11-02T05:57:27.000000Z","surnames":"Roque"}],"user_miscarriage":[{"id":82,"user_id":9601,"place":"Batna","datetime":"2020-08-05 00:00:00","country":"Algeria","created_at":"2020-11-02T06:17:27.000000Z","updated_at":"2020-11-02T06:17:27.000000Z"}],"user_moves":[{"id":12,"user_id":9601,"place":"Bremen","datetime":"2017-08-16 00:00:00","country":"Alemania","created_at":"2020-11-02T06:19:25.000000Z","updated_at":"2020-11-02T06:19:25.000000Z"}]}}')
            let obj = response.data
            obj = obj.user_data
            console.log(obj)
            let template = `Nombre: ${obj.display_name}
Documento: ${obj.document}
Teléfono:${obj.phone_dial} ${obj.phone}
Fecha de Nacimiento:${$day(obj.birth_date).format('YYYY-MM-DD HH:mm:ss')}
Lugar de Nacimiento:${obj.born_place}
País de Nacimiento:${obj.born_country}
País Actual:${obj.current_country}
Lugar Actual:${obj.current_place}
Último Cumpleaños País:${obj.last_birthday_country}
Último Cumpleaños Lugar:${obj.current_place}
Correo Electrónico:${obj.user[0].email}
Fecha de Creación:${$day(obj.created_at).format('YYYY-MM-DD HH:mm:ss')}
Fecha de Actualización:${$day(obj.updated_at).format('YYYY-MM-DD HH:mm:ss')}`
            if (obj.user_children[0]) {
                template = template + `\nHijos:`
                for (let item of obj.user_children)
                template = template + `\n- ${item.names} ${item.surnames} - ${item.born_place}, ${item.born_country} -  ${item.birth_date} `
            }
            if (obj.user_couple[0]) {
                template = template + `\nPareja:`
                for (let item of obj.user_couple)
                template = template + `\n- ${item.names} ${item.surnames} - ${item.born_place}, ${item.born_country} -  ${item.birth_date} `
            }
            if (obj.user_miscarriage[0]) {
                template = template + `\nPerdida de embarazo:`
                for (let item of obj.user_miscarriage)
                template = template + `\n- ${item.place}, ${item.country} -  ${item.datetime} `
            }
            if (obj.user_moves[0]) {
                template = template + `\nMudanza:`
                for (let item of obj.user_moves)
                template = template + `\n- ${item.place}, ${item.country} -  ${item.datetime} `}
            if (obj.user_pet[0]) {
                template = template + `\nMascota:`
                for (let item of obj.user_pet)
                template = template + `\n- ${item.names} - ${item.born_place}, ${item.born_country} -  ${item.birth_date} `}
            // end formatTxt
            const url = window.URL.createObjectURL(new Blob([template]));
            const link = document.createElement('a');
            link.href = url;
            link.setAttribute('download', email + '.txt'); //or any other extension
            document.body.appendChild(link);
            link.click();
          });
          // commit ('setAllCSV', response.data)
        },
        async updateInfo ({commit}, data) {
          data.info.user_data.birth_date = $day(data.info.user_data.birth_date).format('YYYY-MM-DD HH:mm:ss')
          data.info.user_data.display_name = data.info.user_data.names + ' ' + data.info.user_data.surnames
          let response = {}
          response = await axios.put('/admin/users/data/'+data.info.user_data.id, data.info.user_data)
          commit ('updateInfo', response.data)
        },
        async updateCurrentUser ({commit}, data) {
          commit('updateCurrentUser', data)
        }
      }
    },    
    consultation: {
      namespaced: true,
      state: {
        post: []
      },

      mutations: {
        setConsult: (state, info) => state.post = info
      },

      actions: {
        async fetchConsul({commit}) {
          const response = await axios.get('personal-consultation')
          commit ('setConsult', response.data.personal_consultation.reverse())
        }
      }
    },
    child: Child,
    couple: Couple,
    pet: Pet,
    miscarriage: Miscarriage,
    moves: Moves,
    astralCard: AstralCard,
    appoinments: Appoinments,
    accounting: Accounting,

    csvData: {
      namespaced: true,
      state: {
        postData: []
      },

      mutations: {
        setCsvData: (state, info) => state.postData = info
      },

      actions: {
        async fetchCsv({commit}) {
          const response = await axios.get('admin/users/csv')
          commit ('setCsvData', response)
        }
      }
    },
  },



  state: {
    mainLoader: false,
  },
  mutations: {
    setLoader: (state, flag) => state.mainLoader = flag,
  },
  actions: {
    loaderChange({commit}, flag) {
      commit ('setLoader', flag)
    }
  }
})
